import { render, staticRenderFns } from "./ProjectOffers.vue?vue&type=template&id=4c3edf7d&scoped=true"
import script from "./ProjectOffers.vue?vue&type=script&lang=js"
export * from "./ProjectOffers.vue?vue&type=script&lang=js"
import style0 from "./ProjectOffers.vue?vue&type=style&index=0&id=4c3edf7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3edf7d",
  null
  
)

export default component.exports